import React from 'react'

const OffingoVersionManager = () => {
    return (
        <div>OffingoVersionManager</div>
    )
}

export default OffingoVersionManager